import React from 'react'
import { useQuery } from '@apollo/client'
import { CASE_ACTIVITIES } from './queries'
import { fmtFullDateTime } from './helpers'

const ICON = {
    NOTE: 'fa-sticky-note',
    CALL: 'fa-phone',
    SMS: 'fa-comment',
    EMAIL: 'fa-envelope',
    PROMISE_TO_PAY: 'fa-handshake-o',
    PAYMENT_PLAN_CREATED: 'fa-list',
    PAYMENT_SCHEDULED: 'fa-credit-card',
    CHARGE_ATTEMPTED: 'fa-credit-card',
    CHARGE_FAILED: 'fa-times-circle',
    CHARGE_SUCCEEDED: 'fa-check-circle',
    POLICY_APPLIED: 'fa-shield',
    POLICY_REVERTED: 'fa-undo',
}

function prettyType(t) {
    return t
        .toLowerCase()
        .replace(/_/g, ' ')
        .replace(/\b\w/g, (c) => c.toUpperCase())
}

export default function ActivityLog({ caseId }) {
    const { data, loading } = useQuery(CASE_ACTIVITIES, {
        variables: { caseId },
        fetchPolicy: 'cache-and-network',
    })

    const items = data?.allCollectionActivities ?? []

    if (loading && !data) {
        return <div className="cd-activity-empty">Loading activity…</div>
    }
    if (items.length === 0) {
        return <div className="cd-activity-empty">No activity logged yet.</div>
    }

    return (
        <div>
            {items.map((a) => (
                <div key={a.id} className="cd-activity-item">
                    <span className="ico">
                        <i className={`fa ${ICON[a.activityType] || 'fa-sticky-note'}`} />
                    </span>
                    <div className="body">
                        <div className="title">
                            <span>{prettyType(a.activityType)}</span>
                            <span className="ts">{fmtFullDateTime(a.dateAdded)}</span>
                        </div>
                        {a.note && <div className="note">{a.note}</div>}
                        <div className="author">
                            {a.createdById ? `User #${a.createdById}` : 'system'}
                        </div>
                    </div>
                </div>
            ))}
        </div>
    )
}
